module.exports = __webpack_public_path__ + "media/27.b4158e2e.wav";